import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Alert
  } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Card } from "components/Card/Card.jsx";
import { IncomeTaxEntriesCard } from "components/EntriesCards/IncomeTaxEntriesCard.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { fetchIncomeTaxRequest, editIncomeTaxRequest, createIncomeTaxGroupRequest } from "../../../api/incomeTax";

class IncomeTaxForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      resource: {
        annualSalaryFrom: '',
        annualSalaryTo: '',
        taxFixedAmount: '',
        taxRate: '',
        exemptAmount: '',
        effectiveDate: '',
        entries: []
      },
      error: null
    }
  }

  componentDidMount() {
    const { instanceId } = this.props;

    if (instanceId) {
      this.fetchInstance(instanceId);
    } 
  }

  fetchInstance = (id) => {
        fetchIncomeTaxRequest(id,
          result => this.setState(prevState => ({
              resource: {
                  ...prevState.resource,
                  ...result
              }
          })), error => this.setState({ error: 'There was an error' }));
  }

  onChangeDate = (date, field) => {
    let value = moment(date).format("YYYY-MM-DD");

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [field]: value
      }
    }));
  };

  handleFormChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [name]: value,
      },
    }))
  }

  save = () => {
    const {
        annualSalaryFrom,
        annualSalaryTo,
        taxFixedAmount,
        taxRate,
        exemptAmount,
        effectiveDate,
        entries=[]
    } = this.state.resource;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    if (isNewRecord) {

      let data = {
        entries: entries.map(entry => ({ ...entry, effectiveDate })),
        effectiveDate
      };

      createIncomeTaxGroupRequest(data,
        result => this.saveSuccess(result),
        error => this.saveFailure(error)
      );
    } else {

      let data = {
        annualSalaryFrom,
        annualSalaryTo,
        taxFixedAmount,
        taxRate,
        exemptAmount,
        effectiveDate
      };

      editIncomeTaxRequest(instanceId, data,
        result => this.saveSuccess(),
        error => this.saveFailure()
      );
    }
  }

  saveSuccess = (result) => {
    this.setState({ error: null });
    this.handleGoToList()
  }

  handleGoToList = () => {
    const { effectiveDate } = this.state.resource
    this.props.goToList('income-tax', `${moment(effectiveDate).format('YYYY/MM/DD')}`, 'date');
  }

  saveFailure = (error) => {
    this.setState({ error: error.message || 'There was an error saving Income Tax.' })
  }

  addEntry = () => {
    const updatedEntries = [...this.state.resource.entries];
    updatedEntries.push({
        annualSalaryFrom: '',
        annualSalaryTo: '',
        taxFixedAmount: '',
        taxRate: '',
        exemptAmount: '',
    });
    this.setState((prevState) => ({
      resource: {
        ...prevState.resource,
        entries: updatedEntries
      }
    }));
  }

  deleteEntry = (index) => {
    const { entries } = this.state.resource;
    const updatedEntries = [...entries];
    updatedEntries.splice(index, 1);
    this.setState((prevState) => ({
      resource: {
        ...prevState.resource,
        entries: updatedEntries
      }
    }))
  }

  onUpdateEntry = (entry, index) => {
    const { entries } = this.state.resource;
    let updatedEntries = [...entries];
		updatedEntries[index] = {
			...updatedEntries[index],
			...entry
		}
    this.setState((prevState) => ({
      resource: {
        ...prevState.resource,
        entries: updatedEntries
      }
    }));
  }

  render() {

    const {
        annualSalaryFrom,
        annualSalaryTo,
        taxFixedAmount,
        taxRate,
        exemptAmount,
        effectiveDate,
        entries
    } = this.state.resource;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    if (isNewRecord) {
      return (
        <Row>
          <Alert bsStyle="info">
            To create a new group, add all salary tiers that apply and their information
            <br />
            * All tiers will have the same effective date and will work as a group
            <br />
            * The values can be edited later but not the effective date
          </Alert>
          <Col md={12}>
            <Card
              title="New Group"
              content={
                <form>
                  <Button className="card-top-btn btn-primary" onClick={() => this.handleGoToList()}>
                    Back to List
                  </Button>
                  <FormGroup>
                    <ControlLabel>Group Effective Date</ControlLabel>
                    <DatePicker
                      selected={effectiveDate ? moment(effectiveDate, 'YYYY/MM/DD').toDate() : ''}
                      onChange={(date) => this.onChangeDate(date,'effectiveDate')}
                      dateFormat="MM/dd/yyyy"
                      className="dateInput"
                      dropdownMode="select"
                      showYearDropdown
                      timeFormat={false}
                    />
                  </FormGroup>
                  <Card 
                    hideFooter 
                    content={
                      <div>
                        <div className="add-rule-container">
                          <p className="category">Entries <span className="required-star">*</span></p>
                          <Button className="pull-right" bsStyle="primary" bsSize="sm" onClick={this.addEntry}>Add Entry</Button>
                        </div>
                        {
                          entries.map((entry, index) => {
                            return (
                              <IncomeTaxEntriesCard onUpdateEntry={this.onUpdateEntry} index={index} deleteEntry={this.deleteEntry} entry={entry} />  
                            )
                          })
                        }
                      </div>
                    }
                  /> 
                  {this.state.error &&
                  <Alert bsStyle="danger">
                      {this.state.error}
                  </Alert>
                }          
                  <Button bsStyle="primary" pullRight fill onClick={this.save}>
                    {isNewRecord ? "Create" : "Save changes"}
                  </Button>
                  <div className="clearfix" />
                </form>
              }
            />
          </Col>
        </Row>
      )
    } else {
      return (
        <Row>
          <Col md={12}>
            <Card
              title="Edit Group"
              content={
                <form>
                  <Button className="card-top-btn btn-primary" onClick={() => this.handleGoToList()}>
                    Back to List
                  </Button>
                  <FormGroup>
                  <ControlLabel>Annual Salary From</ControlLabel>
                  <FormControl
                    type="text"
                    name="annualSalaryFrom"
                    value={annualSalaryFrom}
                    onChange={this.handleFormChange}
                    placeholder=""
                  />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Annual Salary To</ControlLabel>
                    <FormControl
                      type="text"
                      name="annualSalaryTo"
                      value={annualSalaryTo}
                      onChange={this.handleFormChange}
                      placeholder=""
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Tax Fixed Amount</ControlLabel>
                    <FormControl
                      type="text"
                      name="taxFixedAmount"
                      value={taxFixedAmount}
                      onChange={this.handleFormChange}
                      placeholder=""
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Tax Rate</ControlLabel>
                    <FormControl
                      type="text"
                      name="taxRate"
                      value={taxRate}
                      onChange={this.handleFormChange}
                      placeholder=""
                    />
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Exempt Amount</ControlLabel>
                    <FormControl
                      type="text"
                      name="exemptAmount"
                      value={exemptAmount}
                      onChange={this.handleFormChange}
                      placeholder=""
                    />
                  </FormGroup>
                  <Button bsStyle="primary" pullRight fill onClick={this.save}>
                    Save changes
                  </Button>
                  <div className="clearfix" />
                </form>
              }
            />
          </Col>
        </Row>
      )
    }
  }
}

export default IncomeTaxForm;
